/* eslint-disable react/forbid-prop-types */
import React from 'react';

import PropTypes from 'prop-types';
import { Button, ExpandCollapse, Typography } from '@telus-uds/components-web';

import './styles.css';
import { Box } from '../../../design/css';
import { isOrderFulfillmentTeam } from '../../../utils/request';

import MultiSelect from './multiSelect';
import DateFilter from './dateFilters';

const Filters = ({
  data,
  updateFilters,
  onApplyFilters,
  onResetFilters,
  filterState,
  staticLabels,
  setPage
}) => {
  const {
    status,
    channelId,
    dealership,
    province,
    createdBy,
    productInOrderFor
  } = filterState;
  const {
    filterByChannel,
    filterBySalesRep,
    buttonApply,
    buttonReset,
    filtersDropdownTitle,
    filterByStatus,
    filterByProduct,
    statusFilters,
    productFilters,
    filterByDealership
  } = staticLabels;

  const { salesRepNames, channels, dealerships } = data;

  const channelList =
    channels &&
    channels.map(channel => ({ label: channel.text, value: channel.value }));

  const dealershipList =
    dealerships &&
    dealerships.map(row => ({
      label: row.text,
      value: row.value
    }));

  const statusFiltersList = isOrderFulfillmentTeam
    ? statusFilters.slice(1)
    : statusFilters;

  const onClickResetFilter = () => {
    onResetFilters();
    onApplyFilters(true);
  };

  const multiSelectFilters = [
    {
      label: filterByProduct,
      name: 'productInOrderFor',
      options: productFilters.map(item => ({
        label: item.text,
        value: item.value
      })),
      value: productInOrderFor
    },
    {
      label: filterByStatus,
      name: 'status',
      options: statusFiltersList.map(item => ({
        label: item.text,
        value: item.value
      })),
      value: status
    },
    {
      label: filterBySalesRep,
      name: 'createdBy',
      options:
        salesRepNames &&
        salesRepNames.map(item => ({
          label: item.label,
          value: item.id
        })),
      value: createdBy
    },
    {
      label: 'Filter By Province:',
      name: 'province',
      options: [
        { label: 'Alberta', value: 'Alberta' },
        { label: 'British Columbia', value: 'British Columbia' },
        { label: 'Manitoba', value: 'Manitoba' },
        { label: 'Ontario', value: 'Ontario' },
        { label: 'Quebec', value: 'Québec' },
        { label: 'Saskatchewan', value: 'Saskatchewan' },
        { label: 'Atlantic', value: 'Atlantic' }
      ],
      value: province
    },
    {
      label: filterByChannel,
      name: 'channelId',
      options: channelList,
      value: channelId
    },
    {
      label: filterByDealership,
      name: 'dealership',
      options: dealershipList,
      value: dealership
    }
  ];

  const getMultiSelectFilters = listOfFilters => {
    return listOfFilters.map(({ label, options, name, value }) => {
      return (
        <div>
          <MultiSelect
            updateFilters={updateFilters}
            label={label}
            options={options}
            name={name}
            value={value}
          />
        </div>
      );
    });
  };

  return (
    <ExpandCollapse initialOpen={[]} topDivider={false}>
      {(expandProps) => (
      <ExpandCollapse.Panel
          {...expandProps}
          panelId="filters" control={<Typography heading="h3" variant={{ size: 'h3', bold: true }}>{filtersDropdownTitle}</Typography>}>
        <div className="filters-main">
          {getMultiSelectFilters(multiSelectFilters)}
          <DateFilter filterState={filterState} updateFilters={updateFilters} />
        </div>
        <Box
          display="flex"
          flexDirection="row"
          mt={24}
          mdJustifyContent="flex-start"
          mdWidth={100}
          mdPadding="16px 0"
        >
          <Button
            onPress={() => {
              setPage(1);
              onApplyFilters(false);
            }}
            variant={{ priority: 'low' }}
          >
            {buttonApply}
          </Button>
          <Box width="2"> </Box>
          <Button
            onPress={() => {
              setPage(1);
              onClickResetFilter();
            }}
          >
            {buttonReset}
          </Button>
        </Box>
      </ExpandCollapse.Panel>
          )}
    </ExpandCollapse>
  );
};

Filters.propTypes = {
  setPage: PropTypes.func.isRequired,
  staticLabels: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterState: PropTypes.shape({
    status: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    filterCriteria: PropTypes.string,
    channelId: PropTypes.arrayOf(PropTypes.number),
    dealership: PropTypes.string,
    channelOrgCode: PropTypes.string,
    outletCode: PropTypes.string,
    createdBy: PropTypes.string,
    productInOrderFor: PropTypes.string,
    province: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  data: PropTypes.object.isRequired
};

export default Filters;
